import { client } from './client';
import type { ApiResponse } from '@/types/api';
import type { InvitationResponse, CreateInvitationInput } from '@/types/invitation';

export async function createInvitation(
  input?: CreateInvitationInput,
): Promise<InvitationResponse> {
  const { data } = await client.post<ApiResponse<InvitationResponse>>(
    '/api/v1/teachers/invitations',
    input ?? {},
  );
  return data.data;
}

export async function listInvitations(): Promise<InvitationResponse[]> {
  const { data } = await client.get<ApiResponse<InvitationResponse[]>>(
    '/api/v1/teachers/invitations',
  );
  return data.data;
}
